import dayjs from 'dayjs';

export function formatDate(time, format = 'DD/MM/YYYY') {
  return dayjs(time).format(format);
}